import type { IdealItemDto, IdealRhythm } from '@bk/contracts';

/** Ogni quanto si rinnova un obbligo o si svolge una procedura, in parole. */
export const RHYTHM_LABEL: Record<IdealRhythm, string> = {
  giorno: 'Ogni giorno',
  settimana: 'Ogni settimana',
  mese: 'Ogni mese',
  trimestre: 'Ogni trimestre',
  semestre: 'Ogni sei mesi',
  anno: 'Ogni anno',
  evento: 'Quando serve',
  continuo: 'Sempre',
};

/**
 * I fatti di un obbligo o di una fase (ADR 0133): verso quale ente, ogni quanto, cosa resta a dimostrarlo e da quale
 * area dell'Atlante del Lavoro nasce. Solo ciò che la voce ha.
 */
export function DutyFacts({ v }: { v: IdealItemDto }) {
  const facts = [
    ['Verso', v.ente],
    ['Quando', v.ritmo ? RHYTHM_LABEL[v.ritmo] : null],
    ['Cosa resta', v.prova],
    ['Atlante del Lavoro', v.area_atlante ? `${v.area_atlante.codice} ${v.area_atlante.nome}` : null],
  ].filter((x): x is [string, string] => !!x[1]);
  if (!facts.length) return null;
  return (
    <dl className="grid grid-cols-[auto_minmax(0,1fr)] gap-x-2 gap-y-0.5">
      {facts.map(([k, x]) => (
        <div key={k} className="contents">
          <dt className="text-ink/40">{k}</dt>
          <dd>{x}</dd>
        </div>
      ))}
    </dl>
  );
}

/** I controlli di una procedura (ADR 0133): come si vede che è andata bene, con il codice del risultato atteso dell'Atlante. */
export function Checks({ v }: { v: IdealItemDto }) {
  if (!v.controlli?.length) return null;
  return (
    <div>
      <p className="mb-2 text-[11px] font-semibold uppercase tracking-wide text-ink/40">Come si vede che è andata bene</p>
      <ul className="grid gap-1.5 text-sm">
        {v.controlli.map((c) => (
          <li key={c.controllo} className="flex gap-2">
            <span className="text-accent">✓</span>
            <span>
              {c.controllo}
              {c.codice && <span className="ml-1 text-xs text-ink/40">({c.codice}, Atlante del Lavoro)</span>}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
